import React from 'react'

import { SuccessfulOperation } from './SuccessfulOperation'

import type { SuccessfulOperationWrapperProps } from './types'

export const SuccessfulRequest = ({
  onGoBack,
}: SuccessfulOperationWrapperProps) => (
  <SuccessfulOperation
    onGoBack={onGoBack}
    title="Request Sent"
    description="Our team will find the best options for you. We’ll email you as soon as they’re ready."
    buttonText="Send another request"
  />
)
